<template>
    <div>
        <h1>欢迎使用 tms</h1>
    </div>
</template>
<script>
export default {
};
</script>

<style lang="less">
h1 {
    font-size: 18px;
}
</style>